import { useCallback, useState } from 'react';

export const SCENE_LIST_VIEW_LIST = 'list';
export const SCENE_LIST_VIEW_REEL_HORIZONTAL = 'reel-horizontal';
export const SCENE_LIST_VIEW_REEL_VERTICAL = 'reel-vertical';

export const SCENE_LIST_VIEW = {
  LIST: SCENE_LIST_VIEW_LIST,
  REEL_HORIZONTAL: SCENE_LIST_VIEW_REEL_HORIZONTAL,
  REEL_VERTICAL: SCENE_LIST_VIEW_REEL_VERTICAL,
};

export const SCENE_LIST_VIEW_MODES = [
  SCENE_LIST_VIEW_LIST,
  SCENE_LIST_VIEW_REEL_HORIZONTAL,
  SCENE_LIST_VIEW_REEL_VERTICAL,
];

export const DEFAULT_SCENE_LIST_VIEW_STORAGE_KEY = 'narration-scene-list-view-mode';

export function readSceneListViewMode(
  storageKey = DEFAULT_SCENE_LIST_VIEW_STORAGE_KEY,
  fallback = SCENE_LIST_VIEW_LIST,
) {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (SCENE_LIST_VIEW_MODES.includes(raw)) return raw;
    if (raw === 'horizontal') return SCENE_LIST_VIEW_REEL_HORIZONTAL;
    if (raw === 'vertical') return SCENE_LIST_VIEW_REEL_VERTICAL;
  } catch {
    /* ignore */
  }
  return fallback;
}

export const readStoredSceneListViewMode = readSceneListViewMode;

export function writeSceneListViewMode(
  mode,
  storageKey = DEFAULT_SCENE_LIST_VIEW_STORAGE_KEY,
) {
  if (!SCENE_LIST_VIEW_MODES.includes(mode)) return;
  try {
    window.localStorage.setItem(storageKey, mode);
  } catch {
    /* ignore */
  }
}

export function isReelSceneListView(mode) {
  return mode === SCENE_LIST_VIEW_REEL_HORIZONTAL || mode === SCENE_LIST_VIEW_REEL_VERTICAL;
}

export const isReelViewMode = isReelSceneListView;

export function reelOrientationFromViewMode(mode) {
  return mode === SCENE_LIST_VIEW_REEL_VERTICAL ? 'vertical' : 'horizontal';
}

export const reelOrientationForViewMode = reelOrientationFromViewMode;

export function sceneListViewLabel(mode) {
  if (mode === SCENE_LIST_VIEW_REEL_HORIZONTAL) return 'Horizontal reel';
  if (mode === SCENE_LIST_VIEW_REEL_VERTICAL) return 'Vertical reel';
  return 'List';
}

export function useSceneListViewMode(
  storageKey = DEFAULT_SCENE_LIST_VIEW_STORAGE_KEY,
  { defaultView = SCENE_LIST_VIEW_LIST } = {},
) {
  const [viewMode, setViewModeState] = useState(
    () => readSceneListViewMode(storageKey, defaultView),
  );

  const setViewMode = useCallback(
    (next) => {
      if (!SCENE_LIST_VIEW_MODES.includes(next)) return;
      setViewModeState(next);
      writeSceneListViewMode(next, storageKey);
    },
    [storageKey],
  );

  return [viewMode, setViewMode];
}
